module.exports = __webpack_public_path__ + "img/hxq-a1-0d.prt.1c34cf31.jpg";